/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicComplianceRefresh extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicComplianceRefresh");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicComplianceRefresh.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicComplianceRefresh>): BackgroundJobPayloadForPeriodicComplianceRefresh {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicComplianceRefresh(), model);
        BackgroundJobPayloadForPeriodicComplianceRefresh.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicComplianceRefresh>): BackgroundJobPayloadForPeriodicComplianceRefresh {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicComplianceRefresh.newInstance(<BackgroundJobPayloadForPeriodicComplianceRefresh> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicComplianceRefresh) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicComplianceRefresh.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicComplianceRefresh): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicComplianceRefresh.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
